// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__V7Anm","notes":"Notes_notes__1jyTg","note":"Notes_note__1bDmZ","markdown":"Notes_markdown__1xoZ9"};